var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrap" }, [
    _c("span", {
      domProps: { innerHTML: _vm._s(_vm.row.model.contact.country_flag) },
    }),
    _vm._v("\n    " + _vm._s(_vm.row.model.contact.phone_number) + "\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }